"use strict";

export function initInScope ($scope) {
    // let container = $(".portal-search.d-none"); //only init desktop
    var mobileBreakpointXs = 768;
    var mobileBreakpoint = 992;
    var isMobile = screen.width <= mobileBreakpoint;

    var headerOffset = 70;
    headerOffset = $("header:first").outerHeight();
    // console.log("headerOffset");
    // console.log(headerOffset);
    let dtContainer = $scope.find(".portal-search-desktop .portal-search-container");
    dtContainer.find(".form-control").each(function (e) {
        $(this).on("focus", function (e) {
            dtContainer.addClass("gray");
            let allFormGroups = dtContainer.find(".form-group-inline");
            allFormGroups.removeClass("white");
            allFormGroups.removeClass("nodashed-border");

            let closestFormGroup = $(this).closest(".form-group-inline");
            let thisIndex = allFormGroups.index(closestFormGroup[0]);

            allFormGroups.each(function (i, e) {
                if(i === thisIndex - 1) {
                    $(this).addClass("nodashed-border");
                }
            });

            $(this).parents(".form-group-inline:first").addClass("white");
        });
    });
    dtContainer.find(".js-places-autocomplete").each(function (e) {
        $(this).on("focus", function (e) {
           $(this).attr("placeholder", $(this).data("focus-ph"));
        }).on("blur", function (e) {
            $(this).attr("placeholder", $(this).data("init-ph"));
        });
    });
    let mbContainer = $scope.find(".portal-search-mobile");
    mbContainer.find(".portal-search-click").on("click", function (e) {

    });

    var pullup = $(".portal-search-mobile-pullup");
    var fromToWrapper = pullup.find('.mobile-search-fromto-wrapper');
    // var fromToWrapper = pullup.find('.js-easypicker-container');
    var fixmeTop = fromToWrapper.offset().top;
    let slInput = pullup.find("#search-location .js-places-autocomplete.tt-input");
    let firstClick = true;
    $(".portal-search-mobile").on("click", function (e) {
        if(pullup.hasClass("open")) {
            $("body").removeClass("modal-open");
            pullup.removeClass("open");
        } else {
            $("body").addClass("modal-open");
            pullup.addClass("open");
            if(firstClick) {
                firstClick = false;
                pullup.find("#search-location").collapse("show");
                slInput.focus();
            }

        }
    });
    $(".portal-search-mobile-pullup .portal-search-close").on("click", function (e) {
        $("body").removeClass("modal-open");
        pullup.removeClass("open");
        return false;
    });


    //desktop person plusminus
    let portalSearchHiddenPersons = $scope.find(".portal-search-desktop .portal-search-persons .portal-search__person-select");
    $(".portal-search-desktop .portal-search-persons").on("click", function (e) {
        portalSearchHiddenPersons.show();
    });
    $(document).on("click", function (e) {
        if($(e.target).closest(".portal-search-persons").length === 0 && $(e.target).closest(".portal-search__person-select").length === 0) {
            portalSearchHiddenPersons.hide();
        }
        if($(e.target).closest(".portal-search-desktop").length === 0) {
            dtContainer.removeClass("gray");
            dtContainer.find(".form-group-inline").removeClass("white");
        }

    });

    $scope.find(".portal-search__person-select").each(function () {
        let dummyEl = $(this).parent().find("input.dummy");
        let hiddenInputEl = $(this).parent().find("input.persons-hidden");
        let personsLocale = $(this).data("locale");
        let personLocale = $(this).data("locales");
        let personInput = $(this).find("input");
        let minPersons = $(this).data("min");
        let maxPersons = $(this).data("max");
        $(this).find(".add").on("click", function (e) {
            let value = personInput.val() ? parseInt(personInput.val()) : 0;
            if(value < maxPersons) {
                personInput.val(value + 1);
                hiddenInputEl.val(personInput.val());
                if(personInput.val() <= 1) {
                    dummyEl.val(personInput.val() + " " + personLocale);
                } else {
                    dummyEl.val(personInput.val() + " " + personsLocale);
                }
                personInput.trigger("change");
            }
        });
        $(this).find(".sub").on("click", function (e) {
            let value = personInput.val() ? parseInt(personInput.val()) : 0;
            if(value > minPersons) {
                personInput.val(value - 1);
                hiddenInputEl.val(personInput.val());
                if(personInput.val() <= 1) {
                    dummyEl.val(personInput.val() + " " + personLocale);
                } else {
                    dummyEl.val(personInput.val() + " " + personsLocale);
                }
                personInput.trigger("change");
            }
        });
    });

    if(!isMobile) {
        dtContainer.find('input').on('keydown', function(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                event.preventDefault(); // Prevents form submission
            }
        });
    } else {
        // let ftSomeInfo = pullup.find(".js-easypicker-container .mobile-search-someinfo");
        let ftCollapseHeadline = pullup.find(".js-easypicker-container .portal-search-mobile-collapse");
        let ftCollapseHeadlineSecond = pullup.find(".js-easypicker-container .portal-search-mobile-collapse").eq(1);
        let resetFilterButton = pullup.find(".mobile-filter-reset");
        let submitButton = pullup.find(".mobile-filter-submit");
        let nextButton = pullup.find(".mobile-filter-next");

        pullup.find("#search-fromto").on("show.bs.collapse", function (e) {
            pullup.find("#search-location").collapse("hide");
            ftCollapseHeadline.hide();
            ftCollapseHeadlineSecond.show();

            submitButton.hide();
            nextButton.show();
        });
        pullup.find("#search-fromto").on("shown.bs.collapse", function (e) {
            fixmeTop = fromToWrapper.offset().top;
        })
        pullup.find("#search-fromto").on("hide.bs.collapse", function (e) {
            // console.log("hidden");
            fromToWrapper.removeClass("fixed");
            ftCollapseHeadline.show();
            ftCollapseHeadlineSecond.hide();

            submitButton.show();
            nextButton.hide();
        });

        let slSomeInfo = pullup.find(".portal-search-location .mobile-search-someinfo");
        let slDefaultLocations = pullup.find(".portal-search-location .mobile-search-defaults-locations");
        let slSomeInfoSpan = slSomeInfo.find("span");
        pullup.find("#search-location").on("show.bs.collapse", function (e) {
            slSomeInfo.hide();
            slDefaultLocations.show();
            pullup.find("#search-fromto").collapse("hide");

            submitButton.hide();
            nextButton.show();
        });
        // pullup.find("#search-location").on("shown.bs.collapse", function (e) {
        //     if(!slInput.val()) {
        //         // slInput.trigger("focus");
        //     }
        // });
        pullup.find("#search-location").on("hide.bs.collapse", function (e) {
            if(slInput.val().length <= 0) {
                slSomeInfoSpan.text(slSomeInfoSpan.data("placeholder"));
            } else {
                slSomeInfoSpan.text(slInput.val());
            }

            slSomeInfo.show();
            slDefaultLocations.hide();
            submitButton.show();
            nextButton.hide();
        });
        pullup.find('input').on('keydown', function(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                event.preventDefault(); // Prevents form submission
                nextButton.trigger("click");
            }
        });
        pullup.find(".portal-search-location .twitter-ta-location").on("click", function (e) {
            // console.log("clicking location")
            let optionContent = $(this).find(".option").text();
            // console.log(optionContent);
            slInput.val(optionContent);
            slInput.trigger("change");
        });
        pullup.scroll(function () {                  // assign scroll event listener
            if (pullup.hasClass("open")) {
                var currentScroll = pullup.scrollTop() + headerOffset; // get current position
                // console.log(currentScroll);
                // console.log(fixmeTop);
                if (currentScroll >= fixmeTop) {           // apply position: fixed if you
                    // console.log("got fixed");
                    fromToWrapper.addClass("fixed");
                    if(pullup.find(".easepick-wrapper").css("padding-top") === "0px") {
                        pullup.find(".easepick-wrapper").css("padding-top", fromToWrapper.outerHeight() + "px");
                    }
                } else {
                    // console.log("aint got no fixed");
                    fromToWrapper.removeClass("fixed");
                    pullup.find(".easepick-wrapper").css("padding-top", "0px");
                }
            } else {
                // console.log("aint got no open");
            }
        });
        resetFilterButton.on("click", function (e) {
            e.preventDefault();
            pullup.find(".easypick-from-container .easypick-close").trigger("click");
            // console.log("twitter");
            // console.log(pullup.find(".js-places-autocomplete"));
            pullup.find(".js-places-autocomplete").typeahead('val', null);
            slSomeInfoSpan.text(slSomeInfoSpan.data("placeholder"));
            pullup.find(".portal-search__person-select input").val("");

            pullup.find("#search-location").collapse("hide");
            pullup.find("#search-fromto").collapse("hide");
            pullup.animate({ scrollTop: 0 }, 500);

            resetFilterButton.hide();
            return false;
        });
        // console.log("setting on changes");
        // console.log(pullup.find(".form-control"));
        let allInputs = pullup.find(".form-control:not(.tt-hint)");
        allInputs.on("change", function(e) {
            let dirty = false;
            allInputs.each(function () {
                if($(this).val()) {
                    dirty = true;
                }
            });
            if(dirty) {
                resetFilterButton.show();
            }
        });
        nextButton.on("click", function (e) {
            e.preventDefault();
            let sLoc = pullup.find('[data-target="#search-location"]');
            let sLocEl = pullup.find('#search-location');
            let sFT = pullup.find('[data-target="#search-fromto"]');
            let sFTEl = pullup.find('#search-fromto');
            if(!sLoc.hasClass("collapsed")) {
                sLocEl.collapse("hide");
                sFTEl.collapse("show");
            } else if(!sFT.hasClass("collapsed")) {
                sFTEl.collapse("hide");
            }
            return false;
        });
    }
}